import { observer } from 'mobx-react';
import { Button, ArrowLeftIcon, Modal } from '@gamesb42/ui-kit';
// import { corparateDoc } from "../../index";
import connectionStore from 'pages/Connection/components/connectionStore';
import appStore from 'store/App';

import s from './styles.module.scss';
import { appInfoInst } from '../..';
import userStore from 'store/User';

type Page = 1 | 2 | 3 | 4 | 5;

export const Paginator = observer(() => {
  const emptyArr: number[] = [];
  emptyArr.length = 6;
  emptyArr.fill(1, 1);

  return (
    <div className={s.paginatorHolder}>
      <Button
        icon={<ArrowLeftIcon size={16} />}
        size="large"
        onClick={() => {
          if (appInfoInst.page > 1) {
            appInfoInst.page -= 1;
          } else {
            connectionStore.currentScreen = 'infoScreen';
            appStore.showAccountsDrawer = false;
          }
        }}
        className={s.backBtn}
      >
        Go back
      </Button>

      <div className={s.dotsHolder}>
        {emptyArr.map((item, idx) => {
          return (
            <div className={idx === appInfoInst.page ? s.active : s.inactive} />
          );
        })}
      </div>

      <Button
        violet
        type="primary"
        size="large"
        onClick={async () => {
          if (appInfoInst.isLastStep) {
            // appStore.showConfirmOnboardingModal = true;
            try {
              await appInfoInst.sendData(
                userStore.me?.company?.id.toString() || '',
              );
            } catch (error) {
              console.error('Error submitting app info:', error);
              appStore.setNotification({
                type: 'error',
                title: 'App/Game info was not saved',
                message: 'Please try once again',
                width: 380,
              });

              return;
            }

            // Устанавливаем флаг до обновления статуса
            appInfoInst.isDataSended = true;

            // Обновляем статус онбординга в userStore (force=true для перезагрузки)
            await userStore.getOnboarding(true);

            appStore.showConfirmOnboardingModal = false;
            appStore.showAccountsDrawer = false;
            appInfoInst.page = 1;
            connectionStore.currentScreen = 'infoScreen';

            return;
          }
          appInfoInst.page += 1;
        }}
        className={s.nextBtn}
        // TODO revert
        disabled={!appInfoInst.isStepIsValid[appInfoInst.page as Page]}
      >
        {appInfoInst.isLastStep ? 'Submit' : 'Proceed'}
      </Button>
    </div>
  );
});
